import { Map as ImmutableMap, Record } from 'immutable';
const MultiLangCategories = Record({
  error: null,
  isLoading: false,
  isCreating: false,
  // @ts-expect-error ts-migrate(7009) FIXME: 'new' expression, whose target lacks a construct s... Remove this comment to see the full error message
  categories: new ImmutableMap(),
  primaryLanguage: null,
  lastLoaded: null,
  lastLoadedOptions: null,
  isRequesting: false
});
export default MultiLangCategories;